import React, { useEffect, useState } from "react";
import "./ResultDecisions/resultsearch.css"

const Pagination = ({ data, currentPage, onPageChange, searchQuery }) => {
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        if (data && data.count) {
            // Calcul du nombre total de pages (10 éléments par page)
            const pages = Math.ceil(data.count / 10);
            setTotalPages(pages);
        }
    }, [data]);

    // Fonction pour générer les numéros de page à afficher
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 5; // Nombre maximum de pages à afficher

        // Si le nombre total de pages est inférieur ou égal au nombre maximum de pages visibles
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Sinon, on affiche un nombre limité de pages avec des ellipses
            if (currentPage <= 3) {
                // Si on est proche du début
                for (let i = 1; i <= 4; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push("...");
                pageNumbers.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                // Si on est proche de la fin
                pageNumbers.push(1);
                pageNumbers.push("...");
                for (let i = totalPages - 3; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            } else {
                // Si on est au milieu
                pageNumbers.push(1);
                pageNumbers.push("...");
                pageNumbers.push(currentPage - 1);
                pageNumbers.push(currentPage);
                pageNumbers.push(currentPage + 1);
                pageNumbers.push("...");
                pageNumbers.push(totalPages);
            }
        }

        return pageNumbers;
    };

    // Fonction pour changer de page
    const handlePageClick = (page) => {
        if (page !== currentPage && page !== "...") {
            onPageChange(page);
        }
    };

    // Fonction pour aller à la page précédente
    const goToPreviousPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    // Fonction pour aller à la page suivante
    const goToNextPage = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    // Affichage conditionnel de la pagination
    if (totalPages <= 1) {
        return null; // Ne pas afficher la pagination s'il n'y a qu'une seule page
    }

    const pageNumbers = getPageNumbers();

    return (
        <div className="pagination-wrapper">
            <div className="pagination-info">
                Page {currentPage} sur {totalPages}
            </div>
            <div className="pagination">
                <button
                    className={`pagination-prev ${currentPage === 1 ? 'disabled' : ''}`}
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    aria-label="Page précédente"
                >
                    &lt;
                </button>

                {pageNumbers.map((page, index) => (
                    page === "..." ? (
                        <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
                    ) : (
                        <button
                            key={`page-${page}`}
                            className={`pagination-page ${page === currentPage ? 'active' : ''}`}
                            onClick={() => handlePageClick(page)}
                            disabled={page === currentPage}
                            aria-current={page === currentPage ? "page" : undefined}
                            aria-label={`Page ${page}`}
                        >
                            {page}
                        </button>
                    )
                ))}

                <button
                    className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    aria-label="Page suivante"
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};

export default Pagination;